import { Component, inject, input, signal } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoPipe } from '@jsverse/transloco';
import { produce } from 'immer';
import { GuidelineService } from 'shared/domain';

import { ComponentWidget, GuidelineConditionComponent } from '@treetop/shared/model';
import { GuidelineElementSection, GuidelineElementType } from '@treetop/shared/reference-numbering';

import { DividerComponent } from '../../../../../../../../shared/ui-common/src/lib/components/divider/divider.component';
import { TitleDescriptionComponent } from '../../../chapter-sidebar-wrapper/components/title-description/title-description.component';
import {
  GuidelineSidebarBasics,
  GuidelineSidebarBasicsComponent,
} from '../../../guideline-sidebar-basics/guideline-sidebar-basics.component';
import { TechnicalInfoComponent } from '../../../sub-components/technical-info/technical-info.component';

@Component({
  standalone: true,
  imports: [
    MatTabsModule,
    TitleDescriptionComponent,
    TranslocoPipe,
    TechnicalInfoComponent,
    GuidelineSidebarBasicsComponent,
    DividerComponent,
  ],
  selector: 'guideline-component-sidebar-condition',
  templateUrl: './guideline-component-sidebar-condition.component.html',
  styleUrls: ['./guideline-component-sidebar-condition.component.scss'],
})
export class GuidelineComponentSidebarConditionComponent {
  private guidelineService = inject(GuidelineService);

  public widget = input<ComponentWidget<GuidelineConditionComponent>>();

  protected showAllMedications = signal(false);

  protected handleTitleChanged(title: string): void {
    const newWidget = produce(this.widget(), (draft) => {
      draft.component.title = title;
    });

    this.guidelineService.updateWidget(newWidget.uniqueId, newWidget);
  }

  protected handleBasicsChanged(basics: GuidelineSidebarBasics) {
    const newWidget = produce(this.widget(), (draft) => {
      draft.references = basics.references;
      draft.links = basics.links;
      draft.attachments = basics.attachments;
      draft.resourceTags = basics.resourceTags;
    });

    this.guidelineService.updateWidget(newWidget.uniqueId, newWidget);
  }

  protected readonly GuidelineElementSection = GuidelineElementSection;
  protected readonly GuidelineElementType = GuidelineElementType;
}
